import { Singleton } from '@utils/singleton';

@Singleton
export class LocalStorageService {
  setItem<T>(key: string, value: T): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  getItem<T>(key: string): T | undefined {
    const item = localStorage.getItem(key);
    if (item === null) return undefined;
    return this.safelyParseJSON<T>(item);
  }

  private safelyParseJSON<T>(json: string): T | undefined {
    try {
      return JSON.parse(json) as T;
    } catch {
      return undefined;
    }
  }
}
